import React, { forwardRef, useCallback, useEffect, useImperativeHandle, useState } from "react"
import { toast } from "react-toastify";
import { useForm } from "react-hook-form";
import TextField from "@material-ui/core/TextField";
import Typography from "@material-ui/core/Typography";
import passwordManagmentService from "./../../Services/PasswordManagmentService";
import UsersService from "./../../Services/UsersService";
import auth from "./../../Components/Authenticate";
import OverlapDialog from "../../Components/OverlapDialog";
import {faLock, faSave} from "@fortawesome/free-solid-svg-icons";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";

const PasswordChangeDialogComponent = forwardRef((props, ref) => {
    const [open, setOpen] = useState(false);
    const [title, setTitle] = useState("");
    const [force, setForce] = useState(false);
    const [isLoading, setLoading] = useState(false);
    const { handleSubmit, register, errors, watch } = useForm();
    const [passwordRequirments, setPasswordRequirments] = useState();
    useImperativeHandle(ref, () => ({
        openDialog(title = "Zmień hasło", force = false) {
            setTitle(title);
            setForce(force);
            setOpen(true);
            refreshPasswordParams();
        }
    }));

    const refreshPasswordParams = useCallback(() => {
        passwordManagmentService.get()
            .then(data => {
                setPasswordRequirments(data);
            })
            .catch(error => {
                toast.error(error.message);
            });
    }, [toast]);

    useEffect(() => {
        (async () => {
            await refreshPasswordParams();
        })();
    }, [refreshPasswordParams]);

    const handleDialogClose = () => {
        !force && setOpen(false);
    };

    const onSubmit = (data) => {
        setLoading(true);

        const id = auth.getUserId();
        UsersService.changePassword(id, data.oldPassword, data.newPassword).then(data => {
            toast.success(data.message);
            auth.removeHasToChangePassword();
            setOpen(false);
        }).catch((error) => {
            toast.error(error.data.message);
        }).finally(() => {
            setLoading(false);
        });


    };


    return (
        <OverlapDialog
            title={<><b>{title}</b></>}
            onSubmit={handleSubmit(onSubmit)}
            open={open}
            draggable={true}
            isLoading={isLoading}
            maxWidth="xs"
            overlapContent={<FontAwesomeIcon
                aria-label={"fas fa-lock"} size="2x"
                icon={faLock}
            />}
            handleDialogClose={handleDialogClose}
            submitButton={{ content: "Zapisz", icon: faSave }}
            cancelButton={{ content: "Anuluj" }}
        >

            <TextField
                variant="outlined"
                margin="dense"
                name="oldPassword"
                label="Aktualne hasło"
                autoComplete="off"
                type="password"
                fullWidth
                inputRef={register({
                    required: 'Prosze podać aktualne hasło.'
                })}
            />
            <Typography color="error" variant="caption" display="block" gutterBottom>
                {errors.oldPassword && errors.oldPassword.message}
            </Typography>
            <TextField
                variant="outlined"
                margin="dense"
                name="newPassword"
                label="Nowe hasło"
                autoComplete="off"
                type="password"
                fullWidth
                error={(errors.newPassword && errors.newPassword.message) !== undefined}
                inputRef={register({
                    validate: value => {
                        if (value === "")
                            return "Proszę podać hasło.";
                        if (passwordRequirments?.passLength !== 0 && value.length < passwordRequirments?.passLength)
                            return `Hasło musi posiadać min. ${passwordRequirments?.passLength} znaków.`;
                        if (passwordRequirments?.smallLetter !== 0 && value.toUpperCase() === value)
                            return `Hasło musi posiadać małą literę.`;
                        if (passwordRequirments?.bigLetter !== 0 && value.toLowerCase() === value)
                            return `Hasło musi posiadać wielką literę.`;
                        if (passwordRequirments?.specialChar !== 0 && ! /[ `!@#$%^&*()_+\-=[\]{};':"\\|,.<>/?~]/.test(value))
                            return `Hasło musi posiadać znaki specialne.`;
                    }

                })}
            />
            <Typography color="error" variant="caption" display="block" gutterBottom>
                {errors.newPassword && errors.newPassword.message}
            </Typography>
            <TextField
                variant="outlined"
                margin="dense"
                name="repeatNewPassword"
                label="Powtórz nowe hasło"
                autoComplete="off"
                type="password"
                fullWidth
                error={(errors.repeatNewPassword && errors.repeatNewPassword.message) !== undefined}
                inputRef={register({
                    validate: value =>
                        value === watch('newPassword') || "Proszę poprawnie powtórzyć hasło"
                })}
            />
            <Typography color="error" variant="caption" display="block" gutterBottom>
                {errors.repeatNewPassword && errors.repeatNewPassword.message}
            </Typography>


        </OverlapDialog>
    );
});


export default PasswordChangeDialogComponent;